module.exports = __webpack_public_path__ + "img/5.93f8ef48.png";